import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  stickyButtons: {
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
      '& button': {
        flexGrow: 0,
        width: 140,
      },
    },
  },
}));
